import axios from 'axios';
import moment from 'moment';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'DimValCode','tgl1', 'tgl2', 'nomor', 'kodejurnal', 'kodeacc', 'namaacc'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/bukureklasbc${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
listproblem(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'DimValCode', 'tgl1', 'tgl2', 'nomor', 'kodejurnal', 'kodeacc', 'namaacc'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/bukureklasbc/listproblem${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
detail(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['nomor', 'tanggal'];
            let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
            const { data } = await axios.get(`bukureklasbc/detail${str}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
insert(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.post("bukureklasbc", obj);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            // const { data } = await axios.delete(`bukureklasbc/${encodeURIComponent(obj.nomor)}/${encodeURIComponent(moment(obj.tanggal).format('YYYY-MM-DD'))}`);
            const { data } = await axios.delete(`bukureklasbc?nomor=${encodeURIComponent(obj.nomor)}&tanggal=${encodeURIComponent(moment(obj.tanggal).format('YYYY-MM-DD'))}`);
            
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
printjv(obj = {}) {
    return new Promise(async (resolve, reject) => {
        let url ;
        let str = '';
        try {
            // switch (obj.fsubkode2) {
            //     case 'arinvtt':
            //         str = '?key=' + encodeURIComponent(obj.subkode2);
            //         url = `/arinv/printjv`;
            //         break;

            //     case 'tranbank':
            //         str ='?key=' + encodeURIComponent(obj.subkode2);
            //         if (obj.nomor.substr(1, 1) == 'M'){
            //             url = `/tranbank/printreceivejv`;

            //         } else {
            //             url = `/tranbank/printpaymentjv`;
            //         }
            //         break;

            //     default:
                    str = `?nomor=${encodeURIComponent(obj.nomor)}&tanggal=${encodeURIComponent(moment(obj.tanggal).format('YYYY-MM-DD'))}`;
                    url = `/bukureklasbc/printjv`;
            //         break;
            // }

             url += str;
            const { data } = await axios.get(url);

            const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });

},
exportxls(obj = {}) {
    // return new Promise(async (resolve, reject) => {
     return new Promise((resolve, reject) => {
        try {
            const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'DimValCode', 'tgl1', 'tgl2', 'nomor', 'kodejurnal', 'kodeacc', 'namaacc'];

            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            axios({
                url: `/bukureklasbc/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'list_jurnal.xlsx');
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });

        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

};